<nz-table [nzData]="columns" [nzShowPagination]="false" nzSize="small">
	<thead>
		<tr>
			<th>Column</th>
			<th>Type</th>
			<th>Required</th>
			<th>Format</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let col of columns">
			<td><code>{{col.header}}</code></td>
			<td>
				<nz-tag>{{col.type}}</nz-tag>
			</td>
			<td>
				<nz-tag [nzColor]="col.required ? 'red' : 'default'">
					{{col.required ? 'Required' : 'Optional'}}
				</nz-tag>
			</td>
			<td><code *ngIf="col.format">{{col.format}}</code><span *ngIf="!col.format">-</span></td>
			<td>{{col.description}}</td>
		</tr>
	</tbody>
</nz-table>

<nz-divider nzText="Example header row"></nz-divider>
<code>{{exampleHeader}}</code>

<div class="d-flex justify-content-end mt-3">
	<button nz-button nzType="default" (click)="close()">Close</button>
</div>
